(() => {
  if (window.__aceiiHeaderProductMegaInit) return;
  window.__aceiiHeaderProductMegaInit = true;

  const syncActiveCategory = (root, targetId) => {
    if (!root || !targetId) return;

    root.querySelectorAll("[data-aceii-mega-tab]").forEach((tab) => {
      const isActive = tab.getAttribute("data-aceii-mega-tab") === targetId;
      tab.classList.toggle("is-active", isActive);
      tab.setAttribute("aria-expanded", String(isActive));
    });

    root.querySelectorAll("[data-aceii-mega-category]").forEach((category) => {
      category.classList.toggle("is-active", category.getAttribute("data-aceii-mega-category") === targetId);
    });

    root.querySelectorAll("[data-aceii-mega-panel]").forEach((panel) => {
      panel.classList.toggle("is-active", panel.getAttribute("data-aceii-mega-panel") === targetId);
    });
  };

  const initRoot = (root) => {
    const activeTab = root.querySelector("[data-aceii-mega-tab].is-active");
    const firstTab = root.querySelector("[data-aceii-mega-tab]");
    const tab = activeTab || firstTab;

    if (tab) {
      syncActiveCategory(root, tab.getAttribute("data-aceii-mega-tab"));
    }
  };

  const initAll = () => {
    document.querySelectorAll("[data-aceii-product-mega]").forEach(initRoot);
  };

  document.addEventListener("click", (event) => {
    const tab = event.target.closest("[data-aceii-mega-tab]");
    if (!tab) return;

    const root = tab.closest("[data-aceii-product-mega]");
    if (!root) return;

    event.preventDefault();
    syncActiveCategory(root, tab.getAttribute("data-aceii-mega-tab"));
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll, { once: true });
  } else {
    initAll();
  }
})();
